import { CenterContent, CenterWrapper } from '../EntitySelectionPanelUI';
import { Spinner, SpinnerSize } from '@fluentui/react';

const Loading = () => {
  return (
    <CenterWrapper>
      <CenterContent>
        <Spinner
          label="Loading..."
          labelPosition="bottom"
          size={SpinnerSize.large}
        />
      </CenterContent>
    </CenterWrapper>
  );
};
export default Loading;
